module.exports = __webpack_public_path__ + "img/6_60.a9cf8768.png";